import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DynamicField } from "../interfaces/dynamic-form-model";

@Injectable({ providedIn: 'root' })
export class DynamicFormBuilderService {

  constructor(private fb: FormBuilder) { }

  /** 🔹 Build FormGroup from config */
  buildForm(fields: DynamicField[]): FormGroup {
    const group: Record<string, any> = {};

    fields.forEach(field => {
      if (field.visible) {
        group[field.key] = new FormControl(
          {value: field.defaultValue ?? null,disabled:field.readonly},
         field.required? [Validators.required]:[]
        );
      }
    });

    return this.fb.group(group);
  }

  applyReadonly(form: FormGroup, fields: DynamicField[]) {
    fields.forEach(field => {
      const control = form.get(field.key);
      if (control) {
        field.readonly ? control.disable({ emitEvent: false })
          : control.enable({ emitEvent: false });
      }
    })
  }

  /** 🔹 Patch edit data safely */
  patchForm(form: FormGroup, data: any) {
    if (!data) return;
    form.patchValue(data);
  }
}
